import * as React from "react";
import { ExpandingButton } from "../../../shared/components/buttons/ExpandingButton";

interface Profile {
  id: number;
  [key: string]: any;
}

interface AddFavoriteCandidateProps {
  profile: Profile;
  authenticity_token: string;
  favorited_init: boolean;
  expandDirection?: 'left' | 'right';
}

// Add Favorite API Function
const AddFavorite = ({ profile_id, authenticity_token, callback }: {
  profile_id: number;
  authenticity_token: string;
  callback: (favorited: boolean) => void;
}) => {
  const url = `/profiles/${profile_id}/add_favorite_candidate`;
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": authenticity_token,
    },
  })
    .then((res) => res.json())
    .then((res) => {
      callback(res.status.favorited);
    });
};

// Remove Favorite API Function
const RemoveFavorite = ({ profile_id, authenticity_token, callback }: {
  profile_id: number;
  authenticity_token: string;
  callback: (favorited: boolean) => void;
}) => {
  const url = `/profiles/${profile_id}/remove_favorite_candidate`;
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": authenticity_token,
    },
  })
    .then((res) => res.json())
    .then((res) => {
      callback(res.status.favorited);
    });
};

// Main Component
const AddFavoriteCandidate: React.FC<AddFavoriteCandidateProps> = ({
  profile,
  authenticity_token,
  favorited_init,
  expandDirection = 'right',
}) => {
  const [state, setState] = React.useState({
    favorited: favorited_init,
    loading: false,
  });

  // Sync state with favorited_init prop changes
  React.useEffect(() => {
    setState(prevState => ({
      ...prevState,
      favorited: favorited_init
    }));
  }, [favorited_init]);

  const updateFavoriteState = (favorited: boolean) =>
    setState({
      favorited: favorited,
      loading: false,
    });

  const RemoveFavoriteHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    setState({ ...state, loading: true });
    RemoveFavorite({
      profile_id: profile.id,
      authenticity_token: authenticity_token,
      callback: (f) => updateFavoriteState(f),
    });
  };

  const AddFavoriteHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    setState({ ...state, loading: true });
    AddFavorite({
      profile_id: profile.id,
      authenticity_token: authenticity_token,
      callback: (f) => updateFavoriteState(f),
    });
  };

  return (
    <ExpandingButton
      icon="fad fa-heart"
      text={state.favorited ? "Unfavorite" : "Favorite"}
      variant="favorite"
      active={state.favorited}
      expandDirection={expandDirection}
      onClick={state.favorited ? RemoveFavoriteHandler : AddFavoriteHandler}
      iconColor={state.favorited ? "red" : "grey"}
    />
  );
};

export default AddFavoriteCandidate;
